import React from 'react';
import { connect } from 'react-redux';
import '../../styles/promotion.scss';
import axios from 'axios';
import Cookies from 'universal-cookie';
import Footer from './play_Footer';
import Navbar from './play_Navbar';
import { Navigate } from 'react-router-dom';
import { setResultObject, setPromoState } from '../../actions';
import Modal from '../../modal/default';
import { ParticipationRegisterStatus } from './utils/ParticipationRegisterStatus';
import MyModal from '../../modal/newModal';
import config from '../../configuration.json';
class PromoEnded extends React.Component {

    state = {
        scale: false,
        
    };
    active = false;
    redirections = {};
    componentDidMount() {
        window.scrollTo(0, 0);
        this.cookies = new Cookies();
        window.addEventListener("resize", this.resize.bind(this));
        this.resize();
    }

    resize() {
        if (window.innerWidth <= 760) {
            this.setState({ scale: true });
        }
        else {
            this.setState({ scale: false });
        }
    }

   
    render() {
        return (
            <div className='row'>
                  <Navbar image={config.PlayAndPizza.HeaderIconlUrl} />
               <div>
                <img src="https://bihubstoragepro.blob.core.windows.net/tpzpromos/pepsi/images/IMAGE_PROMO_FINALIZADA.png" alt="Promoción finalizada" style={{ width: '100%', height: 'auto' }} />
               </div>
               <div style={{ textAlign: 'center', marginTop: '20px', fontSize: '24px', fontWeight: 'bold' }}>
                <p>Esta promo ha finalizado</p>
               </div>
               <div style={{ textAlign: 'center', marginTop: '20px' }}>
                <button className="btn play_button" onClick={() => {
                            window.gtag('event', 'PromotionEnded', { 'eventCategory': 'PromotionEnded', 'eventLabel': 'PromotionEnded' });
                            window.location.href = `https://www.telepizza.es/`;
                        }}>IR A TELEPIZZA</button>
               </div>
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        result: state.pageReducer.result,
    };
};

export default connect(mapStateToProps, { setResultObject, setPromoState })(PromoEnded);


